import {
  Component,
  EventEmitter,
  input,
  Input,
  InputSignal,
  Output,
} from '@angular/core';
import {
  ActionButton,
  ActionButtonType,
} from '@shared/models/action-button.model';
import { NgSwitch, NgSwitchCase, NgClass } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-action-button',
    templateUrl: './action-button.component.html',
    styleUrls: ['./action-button.component.scss'],
    imports: [NgSwitch, NgSwitchCase, NgClass, MatTooltip, MatIcon, RouterLink, TranslatePipe]
})
export class ActionButtonComponent {
  readonly DISABLED_SUFFIX = 'Disabled';
  readonly ActionButtonEnum = ActionButtonType;

  readonly row: InputSignal<any> = input<any>({});
  readonly action: InputSignal<ActionButton> = input<ActionButton>({} as ActionButton);

  @Output()
  actionClick: EventEmitter<ActionButton> = new EventEmitter();

  getTooltip(): string {
    return this.action().tooltip ?? this.action().name;
  }

  emitAction(): void {
    this.action().row = this.row();
    this.actionClick.emit(this.action());
  }
}
